import { render, staticRenderFns } from "./expensesDistributionView.vue?vue&type=template&id=38c99246&"
import script from "./expensesDistributionView.vue?vue&type=script&lang=js&"
export * from "./expensesDistributionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports